import {
  DemoLogin,
  GeneralLogin,
  GenesisCareLogin,
  OsuLogin,
  TestLogin,
  VerificationError
} from '@/features/auth/routes';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  AuthorizedLayout,
  LoginLayout,
  LoginNotFound,
  MainLayout,
  NotFound
} from './components/Layout';
import Logout from './features/auth/components/Logout';
import { NewRequest } from './features/requests/routes/NewRequest';
import RequestComplete from './features/requests/routes/RequestComplete';
import { Requests } from './features/requests/routes/Requests';
import { ViewRequest } from './features/requests/ViewRequest';
import useLogging from '@/hooks/logging/useLogging';

export default function App() {
  useLogging();

  return (
    <Routes>
      <Route path="/error" element={<VerificationError />} />
      <Route element={<MainLayout />}>
        <Route index element={<Navigate to="/requests" />} />
        <Route path="/login" element={<LoginLayout />}>
          <Route index element={<GeneralLogin />} />
          <Route path="floridacenterforpancreasdiseases" element={<GenesisCareLogin />} />
          <Route path="osu" element={<OsuLogin />} />
          <Route path="test" element={<TestLogin />} />
          <Route path="demo" element={<DemoLogin />} />
          <Route path="*" element={<LoginNotFound />} />
        </Route>
        <Route path="/" element={<AuthorizedLayout />}>
          <Route path="/requests">
            <Route index element={<Requests />} />
            <Route path=":requestId/view" element={<ViewRequest />} />
            <Route path="splash" element={<RequestComplete />} />
          </Route>
          <Route path="/newrequest/:templateId" element={<NewRequest />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/logout" element={<Logout />} />
      </Route>
    </Routes>
  );
}
